module.exports = __webpack_public_path__ + "static/media/intro3.a41f6bcd.jpg";